import React, { Component } from "react";
import Button from "./Button";

interface ButtonGroupProps {
  buttons: Array<{
    ref?: any;
    icon?: React.ReactNode;
    label?: string;
    disabled?: boolean;
    onClick?: () => void;
    tooltip?: string;
    toolTipEnterDelay?: number;
  }>;
  size?: "sm" | "md" | "lg";
  background?: string;
  sx?: React.CSSProperties;
}

export default class ButtonGroup extends Component<ButtonGroupProps> {
  static defaultProps: Partial<ButtonGroupProps> = {
    buttons: [],
    size: "md",
    background: "white",
  };

  constructor(props: ButtonGroupProps) {
    super(props);
  }

  render() {
    const { buttons, size = "md", background = "white", sx } = this.props;

    return (
      <div
        className="klayo-button-group"
        style={{ borderRadius: Button.borderRadius[size], ...sx }}
      >
        {buttons.map((button, key) => (
          <Button
            key={key}
            ref={button.ref}
            icon={button.icon}
            label={button.label}
            background={background}
            size={size}
            disabled={button.disabled}
            hasBorder={true}
            hasFocusBorder={false}
            onClick={button.onClick}
            tooltip={button.tooltip}
            toolTipEnterDelay={button.toolTipEnterDelay}
            sx={{
              borderRadius:
                key === 0
                  ? `${Button.borderRadius[size]} 0 0 ${Button.borderRadius[size]} !important`
                  : key === buttons.length - 1
                  ? `0 ${Button.borderRadius[size]} ${Button.borderRadius[size]} 0 !important`
                  : "0 !important",
              marginLeft: key ? "-1px" : "0",
            }}
          />
        ))}
      </div>
    );
  }
}
